module.exports = __webpack_public_path__ + "static/media/jp.d78fbe8c.svg";